
import { defineComponent, computed, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ClientDimensions } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "ShiftedVertical",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);

    const returnToTroubleShooting = () => {
      store.dispatch(ActionTypes.SET_MODAL, "troubleShooting");
    };

    const configureTemplate = () => {
      store.dispatch(ActionTypes.SET_MODAL, "alignmentWizard");
    };

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      clientDimensions,
      returnToTroubleShooting,
      configureTemplate,
    };
  },
});
